import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DialogModel } from './dialog.model';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  @Input() dialogModel: DialogModel;
  @Output() onOkClicked: EventEmitter<boolean> = new EventEmitter();
  public hide: boolean;

  constructor() { }

  ngOnInit() {
    this.hide = false;
  }

  buttonClicked(): void {
    this.onOkClicked.emit(this.hide);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dialog/dialog.component.ts